import { useAdDetails } from '@/views/Ads/useAdDetails';
import { ContactType } from '@/api/types/ads.types';

export function useFloatingButtonsVisibility() {
  const { adDetails } = useAdDetails();

  const isChatAvailable =
    adDetails?.isChatAvailable &&
    (adDetails?.contact.type === ContactType.OnlyMessages ||
      adDetails?.contact.type === ContactType.CallsAndMessages);

  const isCallsAvailable =
    adDetails?.isCallsAvailable &&
    (adDetails?.contact.type === ContactType.OnlyCalls ||
      adDetails?.contact.type === ContactType.CallsAndMessages);

  return { isChatAvailable, isCallsAvailable };
}
